import { Icon, l } from '@manychat/manyui'

import { FlowChartTrigger, FlowChartTriggerIconType } from '../types/FlowChartTrigger'

export const FlowChartBroadcastTrigger: FlowChartTrigger = {
  id: 'broadcast',
  icon: {
    type: FlowChartTriggerIconType.ICON,
    icon: Icon.Broadcasting,
  },
  title: l.translate('You send a Broadcast'),
  subtitle: [],
  subtitleIcon: null,
  isActive: true,
  isInteractive: false,
}
